/**
 * Buyer-side Beat Shop filters. Keep aligned with the backend taxonomy exposed
 * by seller/meta. Original values are retained; slash-delimited genre cells are
 * split into atomic tags, and key shorthand/casing aliases are normalized.
 */

export const BEATSHOP_KEYS = [
  'C major',
  'C minor',
  'C# minor',
  'D major',
  'D minor',
  'Eb minor',
  'E major',
  'E minor',
  'F major',
  'F minor',
  'F# minor',
  'G major',
  'G minor',
  'G# major',
  'Ab minor',
  'A major',
  'A minor',
  'Bb minor',
  'B minor',
  'A# minor',
  'D# major',
  'D# minor',
] as const;

export const BEATSHOP_GENRES = [
  'Hip Hop',
  'R&B',
  'Jazz',
  'Alternative',
  'Afrobeats',
  'Trap',
  'Pop',
  'Electronic',
  'Drill',
  'Soul',
  'Acoustic',
  'Folk',
  'Afro',
  'House',
  'Latin',
  'Amapiano',
  'Brazillian Funk',
  'Dance',
  'Funk',
  'Indian',
  'Reggaeton',
  'Drill Rap',
  'Funky',
  'Tropical',
  'West coast',
  'Jersey Club',
  'R&B soul',
  'EDM',
  'Drill trap',
  '80s',
  'Sexy Drill',
] as const;
